import AtiSuIcon from "atisu.svg";
import { authProvidersEnum } from "helpers/enums";
import { ymEvent } from "helpers/system";
import { UmamiManager } from "lib/umami";
import React, { useEffect, useState } from "react";
import { getAuthProviderLink } from "sources/account";

type AtiSuAuthButtonProps = {
    children: React.ReactNode;
    className?: string;
    metricName: string;
};

export default function AtiSuAuthButton({ children, className = "", metricName }: AtiSuAuthButtonProps) {
    const [authLink, setAuthLink] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        getAuthProviderLink(authProvidersEnum.AtiSu).then((atiSuLink) => {
            if (isMounted) {
                setAuthLink(atiSuLink ?? "");
                setLoading(false);
            }
        });

        return () => {
            isMounted = false;
        };
    }, []);

    const startAuthorization = () => {
        if (!authLink) {
            return;
        }

        ymEvent(metricName);
        UmamiManager.track(metricName);
        window.location.assign(authLink);
    };

    return (
        <button
            className={`d-flex justify-content-center align-items-center identity-form__button identity-form__button--outline ${className}`}
            type="button"
            onClick={startAuthorization}
            disabled={loading || !authLink}
        >
            <AtiSuIcon className="mr-1" />
            {children}
        </button>
    );
}
